class SoieCountdown extends HTMLElement {
  connectedCallback() {
    const mode = this.dataset.mode || 'evergreen';
    const hours = Number(this.dataset.hours || 2);
    const key = `soie-countdown-${this.dataset.id || 'store'}`;
    let end;
    if (mode === 'date' && this.dataset.end) end = new Date(this.dataset.end).getTime();
    else {
      end = Number(localStorage.getItem(key));
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600000;
        localStorage.setItem(key, String(end));
      }
    }
    const tick = () => {
      let distance = Math.max(0, end - Date.now());
      const days = Math.floor(distance / 86400000); distance %= 86400000;
      const values = [days, Math.floor(distance / 3600000), Math.floor((distance % 3600000) / 60000), Math.floor((distance % 60000) / 1000)];
      this.querySelectorAll('[data-count]').forEach((el, index) => { el.textContent = String(values[index]).padStart(2, '0'); });
      if (end > Date.now()) this.timer = setTimeout(tick, 1000);
    };
    tick();
  }
  disconnectedCallback() { clearTimeout(this.timer); }
}
if (!customElements.get('soie-countdown')) customElements.define('soie-countdown', SoieCountdown);

const reveal = new IntersectionObserver((entries) => entries.forEach((entry) => {
  if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
}), { threshold: .12 });
document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-soie-reveal]').forEach((el) => reveal.observe(el)));
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-soie-offer-popup]');
  if (!popup || sessionStorage.getItem('soie-2h-offer-popup-shown') === '1') return;
  window.setTimeout(() => { popup.hidden = false; requestAnimationFrame(() => popup.classList.add('is-open')); }, 1200);
});
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-soie-reveal]').forEach((el) => reveal.observe(el)));
document.addEventListener('click', (event) => {
  const popupClose = event.target.closest('[data-soie-offer-close]');
  if (popupClose) {
    const popup = popupClose.closest('[data-soie-offer-popup]');
    popup?.classList.remove('is-open');
    sessionStorage.setItem('soie-2h-offer-popup-shown', '1');
    window.setTimeout(() => { if (popup) popup.hidden = true; }, 300);
    return;
  }
  const option = event.target.closest('[data-soie-bundle-option]');
  if (!option) return;
  const bundle = option.closest('.sb');
  bundle?.querySelectorAll('[data-soie-bundle-option]').forEach((item) => item.classList.toggle('is-selected', item === option));
  const details = option.closest('.product-details') || document.querySelector('[data-template*="product"] .product-details');
  const quantity = details?.querySelector('input[name="quantity"]');
  if (quantity) {
    quantity.value = option.dataset.quantity || '1';
    quantity.dispatchEvent(new Event('input', { bubbles: true }));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const priceBlock = details?.querySelector('product-price [ref="priceContainer"]');
  if (priceBlock) {
    const salePrice = priceBlock.querySelector('.price');
    const comparePrice = priceBlock.querySelector('.compare-at-price');
    if (salePrice && option.dataset.salePrice) salePrice.textContent = option.dataset.salePrice;
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      const compareGroup = comparePrice.closest('[role="group"]');
      if (compareGroup) compareGroup.hidden = !option.dataset.comparePrice;
    }
  }
});

function initSoieMediaPin(root = document) {
  const media = root.querySelector?.('[data-template*="product"] .product-information__media') || document.querySelector('[data-template*="product"] .product-information__media');
  const grid = media?.closest('.product-information__grid');
  if (!media || !grid || media.dataset.soiePinReady === 'true') return;
  media.dataset.soiePinReady = 'true';
  media.classList.add('soie-media-pin');
  let frame = 0;
  const update = () => {
    frame = 0;
    if (window.innerWidth < 750) { media.style.setProperty('--soie-media-pin-y', '0px'); return; }
    const gridTop = grid.getBoundingClientRect().top + window.scrollY;
    const gridHeight = grid.offsetHeight;
    const mediaHeight = media.offsetHeight;
    const header = document.querySelector('#header-component');
    const topOffset = (header?.offsetHeight || 90) + 16;
    const wanted = window.scrollY + topOffset - gridTop;
    const max = Math.max(0, gridHeight - mediaHeight);
    media.style.setProperty('--soie-media-pin-y', `${Math.max(0, Math.min(wanted, max))}px`);
  };
  const requestUpdate = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  new ResizeObserver(requestUpdate).observe(grid);
  requestUpdate();
}
document.addEventListener('DOMContentLoaded', () => initSoieMediaPin());
document.addEventListener('shopify:section:load', (event) => initSoieMediaPin(event.target));

function hasBundlerQuantityBreak(root = document) {
  const candidates = root.querySelectorAll('h1,h2,h3,h4,p,span,div');
  for (const element of candidates) {
    const text = element.textContent?.trim().toLowerCase();
    if (text === 'buy in bulk and get a discount!' || text === 'buy 2 and get a discount!') return true;
  }
  return false;
}

function lockSoieUnitPrice() {
  if (!hasBundlerQuantityBreak()) return;
  document.querySelectorAll('product-price[data-soie-unit-price]').forEach((priceBlock) => {
    const container = priceBlock.querySelector('[ref="priceContainer"]');
    const price = container?.querySelector('.price');
    const compare = container?.querySelector('.compare-at-price');
    if (price && price.textContent.trim() !== priceBlock.dataset.soieUnitPrice) {
      price.textContent = priceBlock.dataset.soieUnitPrice;
    }
    if (compare) {
      const compareValue = priceBlock.dataset.soieUnitComparePrice || '';
      if (compare.textContent.trim() !== compareValue) compare.textContent = compareValue;
      const group = compare.closest('[role="group"]');
      if (group) group.hidden = !compareValue;
    }
  });
}

let soiePriceLockFrame = 0;
const requestSoiePriceLock = () => {
  if (soiePriceLockFrame) return;
  soiePriceLockFrame = requestAnimationFrame(() => {
    soiePriceLockFrame = 0;
    lockSoieUnitPrice();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  requestSoiePriceLock();
  const productMain = document.querySelector('main') || document.body;
  new MutationObserver(requestSoiePriceLock).observe(productMain, {
    subtree: true,
    childList: true,
    characterData: true
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sb').forEach((bundle) => {
    const buyTwo = bundle.querySelector('[data-soie-bundle-option][data-quantity="2"]');
    if (buyTwo) buyTwo.click();
  });
});